import useMods from '@hooks/useMods';

import PropTypes from 'prop-types';
import React from 'react';

const AccordionItem = ({ children, mods={}, className: classNameTail }) => {
    const { className } = useMods(AccordionItem, { mods });

    return (
        <div
            className={ className + (classNameTail ? ' ' + classNameTail : '') }
        >
            { children }
        </div>
    );
};

AccordionItem.displayName = 'Accordion__Item';

AccordionItem.propTypes = {
    children: PropTypes.node,
    mods: PropTypes.object
};

export default AccordionItem;
